export default {
  version: '17.0.7',
  name: '',
  sheetCount: 1,
  customList: [],
  defaultSheetTabStyles: {},
  sheets: {
    Sheet1: {
      name: 'Sheet1',
      isSelected: true,
      activeRow: 7,
      activeCol: 8,
      visible: 1,
      theme: 'Office',
      data: {
        dataTable: {},
        defaultDataNode: {
          style: {
            themeFont: 'Body',
          },
        },
      },
      rowHeaderData: {
        defaultDataNode: {
          style: {
            themeFont: 'Body',
          },
        },
      },
      colHeaderData: {
        defaultDataNode: {
          style: {
            themeFont: 'Body',
          },
        },
      },
      defaultData: {},
      leftCellIndex: 0,
      topCellIndex: 0,
      selections: {
        '0': {
          row: 7,
          col: 8,
          rowCount: 1,
          colCount: 1,
        },
        length: 1,
      },
      rowOutlines: {
        items: [],
      },
      columnOutlines: {
        items: [],
      },
      cellStates: {},
      states: {},
      outlineColumnOptions: {},
      autoMergeRangeInfos: [],
      tables: [
        {
          name: 'gcTable0',
          row: 0,
          col: 0,
          rowCount: 2,
          colCount: 6,
          style: {
            buildInName: 'Medium2',
          },
          autoGenerateColumns: false,
          bindingPath: '文档',
          rowFilter: {
            range: {
              row: 1,
              col: 0,
              rowCount: 1,
              colCount: 6,
            },
            typeName: 'HideRowFilter',
            dialogVisibleInfo: {},
            filterButtonVisibleInfo: {},
            showFilterButton: true,
            filteredOutRows: [],
            tableName: 'gcTable0',
          },
          columns: [],
        },
      ],
      shapeCollectionOption: {
        snapMode: 0,
      },
      printInfo: {
        paperSize: {
          width: 850,
          height: 1100,
          kind: 1,
        },
      },
      protectionOptions: {
        allowResizeRows: true,
        allowResizeColumns: true,
      },
      index: 0,
      order: 0,
    },
  },
  sheetTabCount: 0,
  namedPatterns: {},
  pivotCaches: {},
}
